import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import SES from "aws-sdk/clients/ses";
import config from "@/lib/config";
export default function sendEmail(_x) {
  return _sendEmail.apply(this, arguments);
}

function _sendEmail() {
  _sendEmail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var address, subject, body, adultMode, ses, source, params;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            address = _ref.address, subject = _ref.subject, body = _ref.body, adultMode = _ref.adultMode;
            ses = new SES({
              region: "ap-northeast-1"
            });

            source = function () {
              if (adultMode) {
                return config.email.source.adult;
              } else {
                return config.email.source.vod;
              }
            }();

            params = {
              Destination: {
                ToAddresses: [address]
              },
              Message: {
                Body: {
                  Text: {
                    Data: body,
                    Charset: "utf-8"
                  }
                },
                Subject: {
                  Data: subject,
                  Charset: "utf-8"
                }
              },
              Source: source
            }; // Return-Path、Reply-Toは設定する？

            return _context.abrupt("return", ses.sendEmail(params).promise());

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _sendEmail.apply(this, arguments);
}